import ContentSearch from '../../../../components/revelo-ui/content/content-search';

const ContentSearchTastic = ({ data }) => {
  const { placeholder, noResultsMsg, trackingEventName } = data;

  return <ContentSearch placeholder={placeholder} noResultsMsg={noResultsMsg} trackingEventName={trackingEventName} />;
};

export default ContentSearchTastic;
